import React from 'react';
import TextField from '../../../../Forms/TextField';
import { Dropdown } from '@fluentui/react';

const Features = ({ cobrandData, isBulkUpdate }) => {
    const [selectedItem, setSelectedItem] = React.useState('ymp');

    const options = [
        { key: 'ymp', text: `Your Money Personality`, show: cobrandData?.yourMoneyPersonalityShow || isBulkUpdate },
        { key: 'stress', text: `Stress Score`, show: cobrandData?.stressScore || isBulkUpdate },
        { key: 'credit', text: `Credit Score & Report`, show: cobrandData?.efxCreditScore || isBulkUpdate },
    ];

    return (
        <div className="mt-1">
                      <p>For all images, enter URL with a 'https://cdn.igrad.com/' domain, formatted as .webp. You can convert them here if needed: https://cloudconvert.com/jpg-to-webp.</p>

            <Dropdown
                label="Select Feature"
                selectedKey={selectedItem}
                onChange={(e, i) => setSelectedItem(i.key)}
                options={options.filter((option) => option.show)}
            />
            {selectedItem === 'ymp' && (
                <>
                    <TextField label="Banner Image" placeholder="Enter URL" type="text" inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }} name="ympBannerImage" />
                    <TextField label="Feature Block 1" placeholder="Enter URL" type="text" inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }} name="ympFeatureBlock1" />
                    <TextField label="Feature Block 2" placeholder="Enter URL" type="text" inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }} name="ympFeatureBlock2" />
                    <TextField label="Feature Block 3" placeholder="Enter URL" type="text" inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }} name="ympFeatureBlock3" />
                </>
            )}
            {selectedItem === 'stress' && (
                <>
                    <TextField label="Banner Image" placeholder="Enter URL" type="text"  inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }} name="stressScoreBannerImage" />
                    <TextField
                        label="Feature Block 1"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="stressScoreFeatureBlock1"
                    />
                    <TextField
                        label="Feature Block 2"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="stressScoreFeatureBlock2"
                    />
                    <TextField
                        label="Feature Block 3"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="stressScoreFeatureBlock3"
                    />
                </>
            )}
            {selectedItem === 'credit' && (
                <>
                    <TextField label="Banner Image" placeholder="Enter URL" type="text" name="creditScoreBannerImage" />
                    <TextField
                        label="Feature Block 1"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="creditScoreFeatureBlock1"
                    />
                    <TextField
                        label="Feature Block 2"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="creditScoreFeatureBlock2"
                    />
                    <TextField
                        label="Feature Block 3"
                        placeholder="Enter URL"
                        inputProps={{ pattern: "https://cdn.igrad.com/__.webp" }}
                        type="text"
                        name="creditScoreFeatureBlock3"
                    />
                </>
            )}
        </div>
    );
};

export default Features;
